export default "__VITE_ASSET__688cfe00__"